import { getDateNaissanceInconnueFRFromYYYYMMDD } from 'components/Commun/Form/Date/dateTranformation';

export const formatDataContactGenerique = async (dataForm) => {
    const fichiers = [];

    if (dataForm.piecesJointes) {
        for (let i = 0; i < dataForm.piecesJointes.length; i += 1) {
            // eslint-disable-next-line no-await-in-loop
            fichiers[i] = await dataForm.piecesJointes[i].getFileToSend();
        }
    }

    return {
        theme: dataForm.theme,
        message: dataForm.message,
        pieceJointe: fichiers,
    };
};

export const formatDataContactModificationInforamtionsPersonnelles = async (dataForm) => {
    const fichiers = [];

    if (dataForm.piecesJointes) {
        for (let i = 0; i < dataForm.piecesJointes.length; i += 1) {
            // eslint-disable-next-line no-await-in-loop
            fichiers[i] = await dataForm.piecesJointes[i].getFileToSend();
        }
    }

    return {
        theme: dataForm.theme,
        nom: dataForm.nom,
        prenomUn: dataForm.prenomUn,
        prenomDeux: dataForm.prenomDeux,
        prenomTrois: dataForm.prenomTrois,
        prenomQuatre: dataForm.prenomQuatre,
        sexe: dataForm.sexe,
        dateNaissance: dataForm.dateNaissance,
        lieuNaissance: dataForm.lieuNaissance,
        codePostalNaissance: dataForm.codePostalNaissance,
        paysNaissance: dataForm.paysNaissance,
        nomUsage: dataForm.nomUsage,
        prenomUsuel: dataForm.prenomUsuel,
        nationalite: dataForm.nationalite,
        numeroPieceIdentite: dataForm.numeroPieceIdentite,
        typePieceIdentite: dataForm.typePieceIdentite,
        message: dataForm.message,
        pieceJointe: fichiers,
    };
};

export const formaterDataFormulaireModificationInforamtionsPersonnelles = (dataCompteUsager) => {
    return {
        nom: dataCompteUsager.personnePhysique.nom,
        prenomUn: dataCompteUsager.personnePhysique.prenomUn,
        prenomDeux: dataCompteUsager.personnePhysique.prenomDeux,
        prenomTrois: dataCompteUsager.personnePhysique.prenomTrois,
        prenomQuatre: dataCompteUsager.personnePhysique.prenomQuatre,
        sexe: dataCompteUsager.personnePhysique.sexe === 'Masculin' ? 'M' : 'F',
        dateNaissance: getDateNaissanceInconnueFRFromYYYYMMDD(
            dataCompteUsager.personnePhysique.dateNaissance,
        ),
        lieuNaissance: dataCompteUsager.personnePhysique.lieuNaissance,
        codePostalNaissance: dataCompteUsager.personnePhysique.codePostalNaissance,
        paysNaissance: dataCompteUsager.personnePhysique.paysNaissance.id,
        nomUsage: dataCompteUsager.personnePhysique.nomUsage,
        prenomUsuel: dataCompteUsager.personnePhysique.prenomUsuel,
        nationalite: dataCompteUsager.personnePhysique.nationalite.id,
        numeroPieceIdentite: dataCompteUsager.personnePhysique.pieceIdentite.numeroPieceIdentite,
        typePieceIdentite: dataCompteUsager.personnePhysique.pieceIdentite.typePieceIdentiteId,
    };
};
